module.exports = __webpack_public_path__ + "img/icon-home-credit.5dd95d27.svg";